module.exports = __webpack_public_path__ + "vue/img/BBVA.d1a3ecae.svg";